"use client";
import DesktopModal, { DesktopRefProps } from "@/components/ModalPopup/DesktopModal";
import React from "react";
import dialogManage from "../manager";

const PwaInstall = () => {
    const pwaModalRef = React.useRef<DesktopRefProps>(null);

    React.useEffect(() => {
        dialogManage.registerDialog({
            key: "PwaInstall",
            show() {
                pwaModalRef?.current?.onOpen();
            },
        });
    }, []);

    return <DesktopModal ref={pwaModalRef} source={"components"} />;
};

export default PwaInstall;
